
import { useTranslation } from "react-i18next";

export const Collaborate = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Text content */}
          <div className="space-y-8 animate-fade-in">
            <h2 className="text-3xl font-bold text-gray-900">
              {t('collaborate.title')}
            </h2>
            <p className="text-lg text-gray-600">
              {t('collaborate.subtitle')}
            </p>
            <div className="space-y-6">
              <div className="space-y-2">
                <h3 className="text-xl font-semibold text-gray-900">
                  {t('collaborate.projectGroups.title')}
                </h3>
                <p className="text-gray-600">
                  {t('collaborate.projectGroups.description')}
                </p>
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-semibold text-gray-900">
                  {t('collaborate.videoMeetings.title')}
                </h3>
                <p className="text-gray-600">
                  {t('collaborate.videoMeetings.description')}
                </p>
              </div>
            </div>
          </div>
          
          {/* Right side - Image */}
          <div className="animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <img
              src="https://dynamico.cloud/assets/img/collaborate.png"
              alt="Team Collaboration Features"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
